<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="content">
                <el-form ref="form" label-width="120px" label-position="right" v-if="info" v-loading="load">
                    <h3 style="margin-bottom: 22px">商品信息</h3>
                    <el-form-item label="商品名称：">
                        <p>{{ info.name }}</p>
                    </el-form-item>
                    <el-form-item label="品牌名称：">
                        <p>{{ info.brand_name }}</p>
                    </el-form-item>
                    <el-form-item label="规格名称：">
                        <p>{{ info.spec_name }}</p>
                    </el-form-item>
                    <h3 style="margin-bottom: 22px">竞品信息</h3>
                    <el-form-item :label="`${item.plateform_name}：`" v-for="(item, index) in info.plateform_list" :key="index">
                        <el-link type="primary" @click="open(item.url)">{{ item.url }}</el-link>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            load: false,
            dialogVisible: false,
            info: {
                name: "",
                brand_name: "",
                spec_name: "",
                plateform_list: "",
                status: "",
            },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getInfo();
    },
    methods: {
        ...mapActions({
            detailCompeteProduct: "brand/detailCompeteProduct",
        }),
        open(url) {
            window.open(url);
        },
        handleClose() {
            this.dialogVisible = false;
        },
        getInfo(id) {
            this.load = true;
            let params = {
                id: id,
                token: this.getToken,
            };
            this.detailCompeteProduct(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.info = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.detail {
    .content {
        min-height: 300px;
    }
}
</style>
